import { render } from "./ClaimDeclarationsList.vue?vue&type=template&id=540551d9"
import script from "./ClaimDeclarationsList.vue?vue&type=script&lang=js"
export * from "./ClaimDeclarationsList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__